import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  FETCH_POI_COUNT,
  FETCH_POI_COUNT_ERROR,
  SET_POI_COUNT,
} from '../constants';

const poiCount = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_POI_COUNT),
    switchMap(() =>
      ajax({
        url: `${state$.value.auth.server}/report/poicount?${`since=${
          encodeURIComponent(state$.value.home.sinceDate)
        }&until=${encodeURIComponent(state$.value.home.untilDate)}`}&v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {

          return {
            type: SET_POI_COUNT,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_POI_COUNT_ERROR,
            error,
          })
        )
      )
    )
  );

export default poiCount;
